module.exports = __webpack_public_path__ + "img/noShoppingCart-icon.5b3a4d34.png";